import { AuditModel } from "./auditModel";
import { Address } from "./contacts";

export class Clients {
  AccountingFirmID: string;
  FirmName: string;
  ClientId: string;
  FirstName: string;
  SurName: string;
  NextMettingsDate: string;
  EntityCounts: string;
  Openjobs: string;
  FullName:string;
}

export enum ClientViewUpdate {
  UpdateView = 2,
  UpdatePropFilterView = 5
}

export class ClientListingView {
  id?: any;
  viewId?: number;
  viewName?: string;
  isDefault?: any;
  orderBy?: boolean;
  sortBy?: any;
  entityTypeId?: Number;
  entityType?: any;
  locationId?: any;
  tagsIds?: string;
  managerId?: any;
  division?: any;
  taxsAgentId?: string;
  industryId?: any;
  fromLastActivityDate?: any;
  toLastActivityDate?: any;
  fromFollowUpDate?: any;
  toFollowUpDate?: any;
  isActiveJobs?: any;
  isGSTRegisted?: any;
  isTaxClient?: any;
  annualIncomeMinimum?: any;
  annualIncomeMaximum?: any;
  filterObject?: any;
  statusId?: any;
  flagId?: any;
  partnerName?: any;
  selectedtagIds?: any;
  columnFlagValue?: any;
  public columnSequence?: any = "";
  filterData?: any;
  groupBy?: any;
  viewValue?: string;
  public UserId?: any = "";
  public AccountingFirmId?: any = 0;
  public GridType?: any = "";
  public IsDeleted?: boolean = false;
  public Flag?: any = 0;
}

export class ClientGroupListing {
  item_text: string;
  item_id: Number;
}

export class ClientListing {
  clientShortName: string;
  clientId: any;
  accountingFirmId: any;
  clientCode: string;
  clientName: string;
  entityTypeId: Number;
  entityType: any;
  partnerName: string;
  manager: any;
  managerId: any;
  contactName: string;
  DivisionName: string;
  email: any;
  assignTagsCount: any;
  assignTagIdstr: any;
  crmActivity: boolean;
  lastActivityDate: any;
  annualIncome: any;
  dateofbirth: any;
  taxAgent: any;
  wip: any;
  assignTagIds: any;
  isActive: any;
  tagIds: any;
  isActiveJobs: boolean;
  isGSTRegistered: boolean;
  isTaxClient: boolean;
  location: any;
  status: string;
  acn: string;
  Phone: string;
  statusColor: any;
  salary: any;
  cfdata: any;
  backgroundColor: string;
  textColor: string;
}

export class NewClientListing {
  ClientShortName: string;
  ClientId: any;
  AccountingFirmId: any;
  ClientCode: string;
  ClientName: string;
  EntityTypeId: Number;
  EntityType: any;
  PartnerName: string;
  Manager: any;
  ManagerId: any;
  ContactName: string;
  DivisionName: string;
  Email: any;
  AssignTagsCount: any;
  AssignTagIdstr: any;
  CRMActivity: boolean;
  LastActivityDate: any;
  AnnualIncome: any;
  DateOfBirth: any;
  TaxAgent: any;
  WIP: any;
  AssignTagIds: any;
  IsActive: any;
  TagIds: any;
  IsActiveJobs: boolean;
  IsGSTRegistered: boolean;
  IsTaxClient: boolean;
  Location: any;
  Status: string;
  ACN: string;
  Phone: string;
  StatusColor: any;
  Salary: any;
  cfdata: any;
  BackgroundColor: string;
  TextColor: string;
}

export class CustomGridViewListing {
  id: any;
  viewName: string;
  isDefault: any;
  orderBy: boolean;
  sortBy: any;
  statusId: any;
  flagId: any;
  partnerName: any;
  selectedtagIds: any;
  columnFlagValue: any;
  public columnSequence: any = "";
  filterData: any;
  groupBy: any;
  screenName:any;
}

export class Softwaredetails {
  public  SoftwareDetailId:any;
  public  ClientId:any;
  public  EntityId:any;
  public  SoftwareType:any;
  public  SoftwareName:any;
  public  UserId:any;
  public  Password:any;
  public  LicenceOwner:any;
  length: number;
  softwareDetailId: any;
  invalid: any;
}


export class AdHocJobStatusMilestone  {
  public jobId: any;
  public jobTypeId: any;
  public mileStoneId: string;
  public MilestoneStatus: string;
  public description: string;
  public entityId: any;
  public entityTypeId: any;
  public duration: any;
  public sequency: any;
  public startDate: any;
  public dueDate: any;
}

export enum ClientEnum{

}

export enum Title{
  Mr='Mr',
  Mrs='Mrs'
}

export enum Gender{
  Male='Male',
  Female='Female'
}

export enum HoldingType{
  Percentage='Percentage',
  Unit='Unit'
}

export enum MemberType{
  Member='Member',
  Director='Director',
  SMSFIndividualTrustee='SMSFIndividualTrustee',
  SMSFTrustee='SMSFTrustee'
}

export enum AddressType{
  Home='Home',
  Postal='Postal'
}

export enum NotDetermine{
  NotDetermine='Not Determine'
}

export enum ReferalSource{
  Bank='Bank',
  Solicitor='Solicitor',
  FinancialPlanner='Financial Planner'
}

export enum SoftwareUsed{
  Class='Class',
  MYOB='MYOB',
  Xero='Xero',
  Other='Other'
}

export enum Entity{
  Individual='Individual',
  Corporate='Corporate',
  Trust ='Trust',
  Partnership ='Partnership',
  SMSF='SMSF'
}

export enum SoftwareNames {
    Kloud = 'Kloud',
    Xero = 'Xero',
    NowInfinity = 'NowInfinity',
    CAS360 = 'CAS360',
    ATO = 'ATO',
    Active = 'Active',
    GovReports = 'GovReports',
    Class = 'Class',
    SF360 = 'SF360'
  }

export enum SoftwareNameMapping {
    Kloud = 'Kloud Connect',
    Xero = 'Xero Practice Manager',
    NowInfinity = 'Now Infinity',
    CAS360 = 'CAS360',
    ATO = 'ATO via GovReports',
    GovReports = 'GovReports',
    Active = 'Active',
    Class = 'Class',
    SF360 = 'SF360'
}

export const ConnectionTypeMapping: Record<SoftwareNames, { name: string; type: SoftwareNames }> = {
    [SoftwareNames.Kloud]: { name: 'Kloud Connect', type: SoftwareNames.Kloud },
    [SoftwareNames.Xero]: { name: 'Xero', type: SoftwareNames.Xero },
    [SoftwareNames.NowInfinity]: { name: 'NowInfinity', type: SoftwareNames.NowInfinity },
    [SoftwareNames.CAS360]: { name: 'CAS360', type: SoftwareNames.CAS360 },
    [SoftwareNames.ATO]: { name: 'ATO Via GovReports', type: SoftwareNames.ATO },
    [SoftwareNames.GovReports]: { name: 'GovReports', type: SoftwareNames.GovReports },
    [SoftwareNames.Active]: { name: 'Active', type: SoftwareNames.Active },
    [SoftwareNames.Class]: { name: 'Class', type: SoftwareNames.Class },
    [SoftwareNames.SF360]: { name: 'SF360', type: SoftwareNames.SF360 }
};

export const ConnectionIcons: Record<string, string> = {
    'Kloud': '../../assets/img/xeroIcons/KloudConnect.svg',
    'Xero': '../../assets/img/xeroIcons/XeroImage.png',
    'NowInfinity': '../../assets/img/xeroIcons/Now-Infinity.svg',
    'CAS360': '../../assets/img/xeroIcons/cas-icon.svg',
    'Active': '../../assets/img/xeroIcons/businessfitness_logo.png',
    'GovReports': '../../assets/img/xeroIcons/GovReports_small.png',
    'Class': '../../assets/img/xeroIcons/ClassSmall.png',
    'ATO': '../../assets/img/xeroIcons/Tax-agent-icon.png',
    'SF360': '../../assets/img/xeroIcons/sf360-smallIcon.svg'
};

export const KCAddressTypes = {
  "Physical Address": "physicalAddress",
  "Postal Address": "postalAddress",
  "Registered Address": "registeredAddress",
  "Meeting Address": "meetingAddress",
  "Billing Address": "billingAddress",
  "Delivery Address": "deliveryAddress",  // Add any address here.
};

export const KloudAddressTypesData = [
  {
    "addressTypeId": 1,
    "addressTypeName": "Physical address"
  },
  {
    "addressTypeId": 2,
    "addressTypeName": "Postal address"
  },
  {
    "addressTypeId": 3,
    "addressTypeName": "Registered address"
  },
  {
    "addressTypeId": 4,
    "addressTypeName": "Meeting address"
  },
  {
    "addressTypeId": 5,
    "addressTypeName": "Billing address"
  },
  {
    "addressTypeId": 6,
    "addressTypeName": "Delivery address"
  }
];

export const DefaultAddressFields = ["careOf", "unit", "addressLine1", "addressLine2", "suburb", "state", "postCode", "country"];

export const GetDefaultAddressFieldsWithNAValues = DefaultAddressFields.reduce((acc, field) => {
  acc[field] = "";
  return acc;
}, {} as { [key: string]: string });

export const SubAddressFields: AddressField[] = [
  { label: 'Care Of', key: 'careOf' },
  { label: 'Unit', key: 'unit' },
  { label: 'Address Line 1', key: 'addressLine1' },
  { label: 'Address Line 2', key: 'addressLine2' },
  { label: 'Suburb, State, Post Code', key: 'fullAddress' },
  { label: 'Country', key: 'country' },
];

export const COMMON_FIELDS = [
    { name: 'Match Status', fieldName: 'matchStatus' },
    { name: 'Entity type', fieldName: 'entityType' },
    { name: 'Client code', fieldName: 'clientCode' },
] as const;

export const ADDRESS_FIELDS = [
    { name: 'Physical address', fieldName: 'physicalAddress' },
    { name: 'Postal address', fieldName: "postalAddress" },
] as const;

export const CONTACT_FIELDS = [
    { name: 'Email', fieldName: 'email' },
    { name: 'Phone number', fieldName: 'phone' },
] as const;

export const ENTITY_TYPE_FIELDS: Record<keyof typeof ENTITY_TYPE_FIELD_NAMES, EntityRow[]> = {
    Individual: [
        { name: 'Preferred name', fieldName: 'preferredName' },
        { name: 'First name', fieldName: 'firstName' },
        { name: 'Middle name', fieldName: 'middleName' },
        { name: 'Last name', fieldName: 'lastName' },
        { name: 'DOB', fieldName: 'dateOfBirth' },
        { name: 'Place of birth', fieldName: 'placeOfBirth' },
        { name: 'Gender', fieldName: 'gender' },
        // { name: 'Resident', fieldName: 'resident' },  // comment code belongs to "Resident" field which will be used in the future.
        { name: 'Partner name', fieldName: 'partnerName' },
        { name: 'Manager name', fieldName: 'managerName' },
        { name: 'ABN', fieldName: 'abn' },
        { name: 'Tax client', fieldName: 'isTaxClient' },
        { name: 'DIN', fieldName: 'din' },
        { name: 'Title', fieldName: 'title' },
        ...CONTACT_FIELDS,
    ],
    Company: [
        { name: 'ACN', fieldName: 'acn' },
        { name: 'Company name', fieldName: 'name' },
        { name: 'Trading name', fieldName: 'tradingName' },
        { name: 'Formation date', fieldName: 'formationDate' },
        { name: 'Annual review date', fieldName: 'annualReviewDate' },
        // { name: 'Resident', fieldName: 'resident' },
        { name: 'Partner name', fieldName: 'partnerName' },
        { name: 'Manager name', fieldName: 'managerName' },
        { name: 'ABN', fieldName: 'abn' },
        ...CONTACT_FIELDS,
    ],
    Trust: [
        { name: 'Trust name', fieldName: 'name' },
        { name: 'Type of trust', fieldName: 'trustType' },
        { name: 'Formation date', fieldName: 'formationDate' },
        // { name: 'Resident', fieldName: 'resident' },
        { name: 'Partner name', fieldName: 'partnerName' },
        { name: 'Manager name', fieldName: 'managerName' },
        { name: 'ABN', fieldName: 'abn' },
        ...CONTACT_FIELDS,
    ],
    Partnership: [
        { name: 'Partnership name', fieldName: 'name' },
        { name: 'Formation date', fieldName: 'formationDate' },
        // { name: 'Resident', fieldName: 'resident' },
        { name: 'Partner name', fieldName: 'partnerName' },
        { name: 'Manager name', fieldName: 'managerName' },
        { name: 'ABN', fieldName: 'abn' },
        ...CONTACT_FIELDS,
    ],
    SMSF: [
        { name: 'Name of SMSF', fieldName: 'name' },
        { name: 'Formation date', fieldName: 'formationDate' },
        // { name: 'Resident', fieldName: 'resident' },
        { name: 'Partner name', fieldName: 'partnerName' },
        { name: 'Manager name', fieldName: 'managerName' },
        { name: 'ABN', fieldName: 'abn' },
        ...CONTACT_FIELDS,
    ],
    Default: [
        ...COMMON_FIELDS,
        { name: 'Name', fieldName: 'name' },
        { name: 'ABN', fieldName: 'abn' },
    ]
};

export enum ENTITY_TYPE_FIELD_NAMES {
    Individual = 'Individual',
    Company = 'Company',
    Trust = 'Trust',
    Partnership = 'Partnership',
    SMSF = 'SMSF',
    Default = 'Default',
}

export const ENTITY_TYPE_MAP: Record<string | number, ENTITY_TYPE_FIELD_NAMES> = {
  Individual: ENTITY_TYPE_FIELD_NAMES.Individual,
  SoleTrader: ENTITY_TYPE_FIELD_NAMES.Individual,
  Personal: ENTITY_TYPE_FIELD_NAMES.Individual,
  'Deceased Individual': ENTITY_TYPE_FIELD_NAMES.Individual,
  'Sole Trader': ENTITY_TYPE_FIELD_NAMES.Individual,
  1: ENTITY_TYPE_FIELD_NAMES.Individual,
  Company: ENTITY_TYPE_FIELD_NAMES.Company,
  Association: ENTITY_TYPE_FIELD_NAMES.Company,
  Generic: ENTITY_TYPE_FIELD_NAMES.Company,
  Society: ENTITY_TYPE_FIELD_NAMES.Company,
  CharitableCompany: ENTITY_TYPE_FIELD_NAMES.Company,
  'Government Entity': ENTITY_TYPE_FIELD_NAMES.Company,
  'Club or Society': ENTITY_TYPE_FIELD_NAMES.Company,
  'Not for Profit': ENTITY_TYPE_FIELD_NAMES.Company,
  Other: ENTITY_TYPE_FIELD_NAMES.Company,
  2: ENTITY_TYPE_FIELD_NAMES.Company,
  Trust: ENTITY_TYPE_FIELD_NAMES.Trust,
  Estate: ENTITY_TYPE_FIELD_NAMES.Trust,
  UnitTrust: ENTITY_TYPE_FIELD_NAMES.Trust,
  DiscretionaryTrust: ENTITY_TYPE_FIELD_NAMES.Trust,
  3: ENTITY_TYPE_FIELD_NAMES.Trust,
  Partnership: ENTITY_TYPE_FIELD_NAMES.Partnership,
  LimitedPartnership: ENTITY_TYPE_FIELD_NAMES.Partnership,
  LimitedLiabilityPartnership: ENTITY_TYPE_FIELD_NAMES.Partnership,
  4: ENTITY_TYPE_FIELD_NAMES.Partnership,
  'Self Managed Superannuation Fund': ENTITY_TYPE_FIELD_NAMES.SMSF,
  SuperannuationFund: ENTITY_TYPE_FIELD_NAMES.SMSF,
  PensionFund: ENTITY_TYPE_FIELD_NAMES.SMSF,
  Super: ENTITY_TYPE_FIELD_NAMES.SMSF,
  SMSF: ENTITY_TYPE_FIELD_NAMES.SMSF,
  5: ENTITY_TYPE_FIELD_NAMES.SMSF,
  Default: ENTITY_TYPE_FIELD_NAMES.Default,
};

export const ClientRelationShipsFields: EntityRow[] = [
    { name: 'Type', fieldName: 'type' },
    { name: 'Client', fieldName: 'clientName' },
    { name: 'Entity type', fieldName: 'entityTypeName' },
    { name: 'Start date', fieldName: 'startDate' },
    { name: 'Status', fieldName: 'status' },
    { name: 'Connections', fieldName: 'connections' },
]

export interface AddressField {
    label: string;
    key: string;
}

export interface EntityRow {
    name: string;
    fieldName: string;
};

export interface CreateClientOrContactPayload {
  name: string;
  middleName: string;
  lastName: string;
  entityTypeId: number;
  phone: string;
  email: string;
  dateOfBirth: Date | string | null;
  formationDate: Date | string | null;
  annualReviewDate: Date | string | null;
  physicalAddressLine1: string;
  physicalAddressLine2: string;
  physicalSuburb: string;
  physicalState: string;
  physicalCountry: string;
  physicalPostCode: string;
  postalAddressLine1: string;
  postalAddressLine2: string;
  postalSuburb: string;
  postalState: string;
  postalCountry: string;
  postalPostCode: string;
  relationId: string;
  clientId: number;
  connectionType: string;
  connectionId: string;
  mappingType: 'Client' | 'Contact';
  contextClientId: number;
  contextEntityTypeId: number;
}

export interface CreateClientPayload extends CreateClientOrContactPayload {
  preferredName: string;
  title: string;
  tfn: string;
  partnerId: number | null;
  managerId: number | null;
  divisionId: number | null;
}

export interface CreateContactPayload extends CreateClientOrContactPayload {
  gender?: string | null;
  isSamePhysical?: boolean;
  contestType?: string;
  backgroundColor?: string;
  textColor?: string;
  contactType?: string;
}

export class Client extends AuditModel {
  public clientId: number
  public accountingFirmId: number
  public title: string
  public firstName: string
  public middleName: string
  public surname: string
  public gender: string
  public dateOfBirth: any
  public placeOfBirth: any
  public maritalStatus: boolean = false
  public spouseName: string
  public spouseId: number = 0;
  public anniversaryDate: any
  public noOfChildren: any
  public residencyStatus: any
  public occupation: any
  public industry: any
  public company: any
  public salary: any
  public annualIncome: any
  public homePhone: any
  public mobileNumber: any
  public workPhone: any
  public email: any
  public notes: any
  public archive_By: any
  public firmName: string
  public nextMeetingDate: string
  public entityCounts: number
  public openJobs: number
  public fullName: string
  public partnerId: number
  public addresses: Address[] = [];
}

export class ClientActivity extends AuditModel {
  public ActivityId: number = 0;
  public ClientId: number;
  public ActivityName: string;
  public Description: string;
  public Status: string;
  public Priority: string;
  public DueDate: string;
  public assignee: string;
  public Created_At;
}

export class Clientdetails extends AuditModel {
  public physicalAddress: string;
  public postalAddress: string;
  public isPhysicalAddressFav: boolean;
  public isPostalAddressFav: boolean;
  public physicalCareOf:string;
  public postalCareOf:string;
  public clientId: any;
  public entityTypeId: any;
  public entityType: string;
  public prospect: boolean = false;
  public clientCode: string;
  public clientProfileImg: string;
  public title: string;
  public firstname: string;
  public middlename: string;
  public lastname: string;
  public preferredname: string;
  public mailingName: string;
  public dateofbirth: any;
  public strdateofbirth: any;
  public placeofbirth: string;
  public gender: string;
  public emailaddress: string;
  public phonenumber: string;
  public linkedinprofileID: string;
  public physicaladdress: string = '1';
  public physicaladdressline1: string = null;
  public physicaladdressline2: string = null;
  public physicalsuburb: string = null;
  public physicalstate: any;
  public physicalpostcode: string = null;
  public physicalcountry: string;
  public postaladdress: string = '2';
  public postaladdressline1: string = null;
  public postaladdressline2: string = null;
  public postalsuburb: string = null;
  public postalstate: any;
  public postalpostcode: string = null;
  public postalcountry: string;
  public industry: string;
  public role: string;
  public salary: string;
  public annualincome: string;
  public istaxclient: boolean = false;
  public islodgeactivity: boolean = false;
  public tFN: string;
  public aBN: string;
  public aCN: string;
  public taxAgent: string;
  public gST: boolean = false;
  public resident: boolean = false;
  public bankname: string;
  public bankaccountname: string;
  public bankBSB: string;
  public bankAccountnumber: string;
  public trustName: string;
  public trustType: string;
  public website: string;
  public xeroMappingId: string;
  public companyName: string;
  public tradingName: string;
  public partnershipname: string;
  public smsfName: string;
  public softwareType: string;
  public softwareName: string;
  public accountingfirmmid: any;
  public partnername: string;
  public managername: string;
  public managerId: string;
  public teamId:number;
  public teamName:string;
  public partnerId: string;
  public isContact: boolean = false;
  public isRelationship: boolean = false;
  public age: number = 0;
  public stateName: string;
  public countryName: string;
  public ContactCount: number = 0;
  public isPostImpotent: boolean = false;
  public addressPoolClientMapping: any;
  public addressPoolContactMapping: any;
  public contactId: any = null;
  public contactIds: string;
  public csalutation: string;
  public cfirstName: string;
  public cmiddleName: string;
  public clastname: string;
  public cgender: string;
  public cdateOfBirth: any;
  public cstrdateOfBirth: any;
  public ccontactType: number = 0;
  public cphone: any;
  public cemail: any;
  public ccompanyName: any;
  public cphysicaladdressline1: string;
  public cphysicaladdressline2: string;
  public cphysicalsuburb: string;
  public cphysicalstate: string;
  public cphysicalcountry: string;
  public cphysicalpostalpostcode: string;
  public concustomfieldsData: string;
  public customfieldsData: string;
  public divisionId: any;
  public officeId: string | null;
  public isSamePhysical: boolean = true;
  public strannualReviewDate: any;
  public strformationDate: any;
  public formationDate: any;
  public annualReviewDate: any;
  public bPayReference: string; // Dev - Surya L, Date - Oct-30-2025, CUST-8413
  public backgroundColor: string;
  public textColor: string;
  public tfn: string;
  public dIN: string;
  public din: string;
  public physicalAddressfulltext: string;
  public isphysicalAddressSeeMore: boolean = true;
  public posatalAddressfulltext: string;
  public isposatalAddressSeeMore: boolean = true;
  public dateOfDeath: any;
  public deRegistrationDate: any;
  public clientStartDate: any;
  public clientEndDate: any;
  public emailPoolClientMapping: EmailPoolClientMapping[];
  public phonePoolClientMapping: PhonePoolClientMapping[];
  public salutation: string;
  public isManageBillerReference: boolean = false;
  public tagIdsJson: string;
  public bPayAlgorithm: number = 0;
  public oldBpayReference: string;
}

export class ClientProfileEntityList extends AuditModel {
  public EntityName: string
  public EntityType: string
  public ABN: string
  public Primarycontact: string
  public JobType: string
  public LodgementDate: Date
  public JobCount: string
  public Status: boolean
}

export class EmailPoolClientMapping {
  public emailPoolId: number;
  public emailPoolMappingId: number;
  public emailTypeId: number;
  public emailId: string;
  public isFavourite: boolean;
  isPreferred: any;
}

export class PhonePoolClientMapping {
  public phonePoolId: Number;
  public phonePoolMappingId: Number;
  public phoneTypeId: Number;
  public phoneNumber: string;
  public isFavourite: boolean;
  public isPreferred: boolean;
  public countryId: any;
  public isdCode: string;
}
